import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { TituloReceberFilter } from '../filter';
import { TituloReceberSearch } from '../titulo-receber-search';
import { TituloReceberSearchTotal } from '../titulo-receber-search-total';

@Injectable({
    providedIn: 'root'
})
export class TituloReceberSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/tituloreceber`;
    }

    /** Realizada a pesquisa os títulos a receber */
    search(filter: TituloReceberFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<TituloReceberSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<TituloReceberSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa dos títulos receber */
    getTotais(filter: TituloReceberFilter): Observable<TituloReceberSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<TituloReceberSearchTotal>(`${this.pathApi}/0/total`, {params});
    }

}
